import * as React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import Divider from "@mui/material/Divider";
import { Grid } from "@mui/material";
import "./skills.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  textAlign: "center",
  color: "white",
  backgroundColor: "transparent !important",
}));
const theme = createTheme();

theme.typography.h5 = {
  fontSize: "16px",
  minHeight: "16vh",
  padding: "20px !important",
  "@media (min-width:600px)": {
    fontSize: "18px",
    minHeight: "23vh",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "18px",
    minHeight: "21vh",
  },
};
theme.typography.h3 = {
  fontSize: "30px",
  "@media (min-width:600px)": {
    fontSize: "32px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "32px",
  },
};

const Skills = () => {
  return (
    <Box id="skills" sx={{ textAlign: "center" }}>
      <ThemeProvider theme={theme}>
        <Typography
          gutterBottom
          variant="h3"
          component="div"
          sx={{ textAlign: "center", pt: 7, pb: 4 }}
        >
          SKILLS
          <Divider variant="middle" />
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3} sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok" sx={{ py: 4 }}>
                  <span>Front-End</span>
                  {/* <br style={{ margin: '10px 0px'}}/> */}
                  <hr />
                  HTML, CSS, JavaScript, ReactJS, TailwindCSS, Material-UI,
                  Bootstrap
                  <Box sx={{ mt: 2 }}>

                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
                      alt="html5"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg"
                      alt="css3"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg"
                      alt="bootstrap"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                      alt="javascript"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
                      alt="react"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://reactnative.dev/img/header_logo.svg"
                      alt="reactnative"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg"
                      alt="redux"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg"
                      alt="sass"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg"
                      alt="tailwind"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />{" "}
                    <img
                      src="https://img.icons8.com/color/452/material-ui.png"
                      alt="MUI"
                      width="40"
                      height="40"
                    />{" "}
                  </Box>
                </Typography>
              </Item>
            </Grid>
            <Grid item xs={12} md={3} sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok" sx={{ py: 4 }}>
                  <span>Back-End</span>
                  <hr />
                  NodeJS, ExpressJS, MongoDB and MySQL
                  <Box sx={{ mt: 2 }}>

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg"
                        alt="express"
                        width="40"
                        height="40"
                      />{" "}
                  
                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
                        alt="mongodb"
                        width="40"
                        height="40"
                      />{" "}
                 
                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
                        alt="mysql"
                        width="40"
                        height="40"
                      />{" "}
                
                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg"
                        alt="nodejs"
                        width="40"
                        height="40"
                      />{" "}
                   
                  </Box>
                </Typography>
              </Item>
            </Grid>
            <Grid item xs={12} md={3} sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok" sx={{ py: 4 }}>
                  <span>Tools</span>
                  <hr />
                  VS Code, Firebase, Heroku, Netlify and Chrome Dev tools
                  <Box sx={{ mt: 2 }}>
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png"
                      alt="vs cose"
                      width="40"
                      height="40"
                    />{" "}
                
                      <img
                        src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                        alt="firebase"
                        width="40"
                        height="40"
                      />{" "}
                  
                      <img
                        src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
                        alt="git"
                        width="40"
                        height="40"
                      />{" "}
                  
                      <img
                        src="https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg"
                        alt="heroku"
                        width="40"
                        height="40"
                      />{" "}

                  </Box>
                </Typography>
              </Item>
            </Grid>
            <Grid item xs={12} md={3} sx={{ pb: 1 }}>
              <Item>
                <Typography variant="h5" className="skillsbgok" sx={{ py: 4 }}>
                  <span>Academic Skills</span>
                  <hr />
                  C/C++, Java, Data Structures and Algorithms, DBMS,
                  Linux(Ubuntu)
                  <Box sx={{ mt: 2 }} className="boxt">

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg"
                        alt="c"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg"
                        alt="cplusplus"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
                        alt="java"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg"
                        alt="linux"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg"
                        alt="php"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
                        alt="python"
                        width="40"
                        height="40"
                      />{" "}

                      <img
                        src="https://raw.githubusercontent.com/devicons/devicon/master/icons/django/django-original.svg"
                        alt="django"
                        width="40"
                        height="40"
                      />{" "}

                  </Box>
                </Typography>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default Skills;

//rgb(25, 49, 96) none repeat scroll 0% 0%
